/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClaimedPrize } from './ClaimedPrize';
import {
    ClaimedPrizeFromJSON,
    ClaimedPrizeFromJSONTyped,
    ClaimedPrizeToJSON,
} from './ClaimedPrize';

/**
 * 
 * @export
 * @interface ClaimedPrizesResponse
 */
export interface ClaimedPrizesResponse {
    /**
     * List of claimed prizes for the wallet (action_data excluded for security)
     * @type {Array<ClaimedPrize>}
     * @memberof ClaimedPrizesResponse
     */
    data: Array<ClaimedPrize>;
}

/**
 * Check if a given object implements the ClaimedPrizesResponse interface.
 */
export function instanceOfClaimedPrizesResponse(value: object): value is ClaimedPrizesResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function ClaimedPrizesResponseFromJSON(json: any): ClaimedPrizesResponse {
    return ClaimedPrizesResponseFromJSONTyped(json, false);
}

export function ClaimedPrizesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimedPrizesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ClaimedPrizeFromJSON)),
    };
}

export function ClaimedPrizesResponseToJSON(value?: ClaimedPrizesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(ClaimedPrizeToJSON)),
    };
}

